import * as React from 'react';
import Select from 'antd/lib/select';
import './Selector.scss';

export interface ISelectorData {
	label: string;
	value: string | number;
}

export interface ISelectorProps {
	placeholder: string;
	data: ISelectorData[];
	onChange: (value: string | number) => void;
}

const Selector = (props: ISelectorProps) => {
	const [sel, setSel] = React.useState();
	if (props.data.length === 0 && sel) {
		setSel(undefined);
	}
	return <Select
		allowClear
		value={sel}
		onChange={(value: any)  => { setSel(value); props.onChange(value); }} dropdownClassName="Selector-Menu" placeholder={props.placeholder} className={`Selector ${sel ? 'active' : ''}`} >
		{props.data.map(d => <Select.Option key={d.value} value={d.value}>{d.label}</Select.Option>)}
	</Select>
};
export default Selector;
